/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Current_StatusInputs */

const en_current_status = /** @type {(inputs: Current_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current Status`)
};

const es_current_status = /** @type {(inputs: Current_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado actual`)
};

const fr_current_status = /** @type {(inputs: Current_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statut actuel`)
};

const de_current_status = /** @type {(inputs: Current_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktueller Status`)
};

const ja_current_status = /** @type {(inputs: Current_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在のステータス`)
};

const zh_current_status = /** @type {(inputs: Current_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前状态`)
};

const ar_current_status = /** @type {(inputs: Current_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الحالة الحالية`)
};

const id_current_status = /** @type {(inputs: Current_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status Saat Ini`)
};

const it_current_status = /** @type {(inputs: Current_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status Attuale`)
};

const ru_current_status = /** @type {(inputs: Current_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Текущий статус`)
};

const pt_current_status = /** @type {(inputs: Current_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status Atual`)
};

const ko_current_status = /** @type {(inputs: Current_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`현재 상태`)
};

/**
* | output |
* | --- |
* | "Current Status" |
*
* @param {Current_StatusInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const current_status = /** @type {((inputs?: Current_StatusInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Current_StatusInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_current_status(inputs)
	if (locale === "es") return es_current_status(inputs)
	if (locale === "fr") return fr_current_status(inputs)
	if (locale === "de") return de_current_status(inputs)
	if (locale === "ja") return ja_current_status(inputs)
	if (locale === "zh") return zh_current_status(inputs)
	if (locale === "ar") return ar_current_status(inputs)
	if (locale === "id") return id_current_status(inputs)
	if (locale === "it") return it_current_status(inputs)
	if (locale === "ru") return ru_current_status(inputs)
	if (locale === "pt") return pt_current_status(inputs)
	return ko_current_status(inputs)
});